var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0122 13.7754V9.89499L18.0122 9.87325C18.0069 6.01473 14.8803 2.88809 11.0217 2.88282L11 2.88281L10.9783 2.88282C7.11974 2.88809 3.9931 6.01473 3.98783 9.87325L3.98782 9.89499V13.7754L2.07637 17.339C1.65964 18.1159 1.45128 18.5044 1.49166 18.8216C1.52689 19.0984 1.6762 19.3479 1.90348 19.5098C2.16391 19.6953 2.60472 19.6953 3.48635 19.6953H18.5137C19.3953 19.6953 19.8361 19.6953 20.0965 19.5098C20.3238 19.3479 20.4731 19.0984 20.5083 18.8216C20.5487 18.5044 20.3404 18.1159 19.9236 17.339L19.9236 17.339L18.0122 13.7754Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 2.88281V1.13281",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0625 19.8047C14.0625 21.4961 12.6914 22.8672 11 22.8672C9.30863 22.8672 7.9375 21.4961 7.9375 19.8047",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotice);
export default __webpack_public_path__ + "static/media/notice.262d57cc090507b177d7b3b5d5ecf0cb.svg";
export { ForwardRef as ReactComponent };